import { motion, useScroll, useSpring } from 'framer-motion';

// Thin gold progress bar pinned to the very top of the viewport, reflecting
// how far the visitor has scrolled down the current page.
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 200, damping: 30, restDelta: 0.001 });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-[2px] bg-[hsl(var(--lxra-gold))] z-[60] origin-left"
      style={{ scaleX }}
      data-testid="scroll-progress-bar"
    />
  );
};
